import { useCallback } from "react";
import { VariaveisAmbiente } from "../../../../config";
import { useApiBase } from "../../base/api-base";
import { OtimizarRotaModel } from "../../../../model/api/rota/otimizar-rota-model";

export function usePostOtimizarRota() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const postOtimizarRota = useCallback(
        (model: OtimizarRotaModel) => {
            return invocarApi({
                url: `/${VariaveisAmbiente.gatewayVersion}/rota/otimizar`,
                method: "POST",
                headers: { "Content-Type": "application/json" },
                data: JSON.stringify(model),
                enviarTokenUsuario: true,
            });
        }, [invocarApi]);

    return {
        ...outrasPropriedades,
        postOtimizarRota,
    };
}
